<template>
    <div class="schedule-legend">
        <h3 class="legend-title">{{ $t('legend.legend') }}</h3>
        <ul class="legend-list no-bullet">
            <slot>
                <li class="legend-item">
                    <span class="icon">
                        <IconUpArrow width="8" height="16" />
                    </span>
                    {{ $t('legend.boarding_only') }}
                </li>
                <li class="legend-item">
                    <span class="icon">
                        <IconDownArrow width="8" height="16" />
                    </span>
                    {{ $t('legend.drop_off_only') }}
                </li>
                <li v-for="headsign in otherHeadsigns" :key="headsign.idVoyage" class="legend-item">
                    <span class="icon">
                        <span class="end-bar" :style="{ 'background-color': headsign.color }"></span>
                    </span>
                    {{ $t('legend.route_end') }}:
                    {{ headsign.lieuFinDesc }}
                </li>
                <li class="legend-item"><span class="icon" aria-hidden="true">—</span> {{ $t('legend.no_departure_hour') }}</li>
                <li class="legend-item">
                    <span class="icon">
                        <IconRealTime width="20" height="20" />
                    </span>
                    {{ $t('legend.real_time') }}
                </li>
                <li class="legend-item">
                    <span class="icon pulse">
                        <IconBus width="24" height="24" />
                    </span>
                    {{ $t('legend.upcoming_departure') }}
                </li>
                <li class="legend-item">
                    <span class="icon">
                        <IconTransfer width="20" height="12" />
                    </span>
                    {{ $t('legend.correspondences') }}
                </li>
                <li class="legend-item">
                    <span class="icon unserved"></span>
                    {{ $t('legend.unserved_stop') }}
                </li>
            </slot>
        </ul>
    </div>
</template>

<script setup>
import IconUpArrow from '@@/icons/up-arrow.svg';
import IconDownArrow from '@@/icons/down-arrow.svg';
import IconRealTime from '@@/icons/realtime.svg';
import IconBus from '@@/icons/menu/bus.svg';
import IconTransfer from '@@/icons/transfer.svg';

defineProps({
    otherHeadsigns: {
        type: Array,
        default: () => [],
    },
});
</script>

<style lang="scss">
.schedule-legend {
    margin: auto 0 16px 16px;
    border-radius: 15px;
    overflow: hidden;
    border: 1px solid $color-black-8;
    .legend-title {
        @include rem-typo(16px);
        margin: 0;
        padding: 16px;
        color: $color-white;
        background-color: $color-blue-60;
        @include breakpoint(xlarge) {
            @include rem-typo(20px);
        }
    }
    .legend-list {
        padding: 16px;
        border-width: 0 1px 1px;
        background-color: $color-white;
    }
    .legend-item {
        @include rem-typo(16px);
        display: flex;
        align-items: center;
        margin: 5px 0;
        .icon {
            display: flex;
            width: 25px;
            height: 25px;
            margin-right: 10px;
            font-family: 'Lucida Grande';
            align-items: center;
            justify-content: center;
        }
        .end-bar {
            content: '';
            display: block;
            width: 25px;
            height: 4px;
            margin: auto;
        }
        .unserved {
            display: inline-block;
            width: 24px;
            height: 24px;
            background-image: url('@@/img/unserved-stop.svg');
        }
    }
}
</style>
